
(function() {
  var result = { translations: { "ro": { "i18n": { "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "duration": { "days": "{{ days }} zile", "hours": "{{ hours }} ore", "hoursAndMinutes": "{{ hours }} ore {{ minutes }} min", "minutes": "{{ minutes }} min", "seconds": "{{ seconds }} sec", "shortForm": { "days": "{{ days }}z", "hours": "{{ hours }}h", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m", "minutes": "{{ minutes }}m", "seconds": "{{ seconds }}s" } }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ro": "static-7.986"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.986",
    "ar-eg": "static-7.986",
    "bg": "static-7.986",
    "bn": "static-7.986",
    "ca-es": "static-7.986",
    "cs": "static-7.986",
    "da": "static-7.986",
    "de": "static-7.986",
    "el": "static-7.986",
    "en-gb": "static-7.986",
    "en": "static-7.986",
    "es-mx": "static-7.986",
    "es": "static-7.986",
    "fi": "static-7.986",
    "fr-ca": "static-7.986",
    "fr": "static-7.986",
    "he-il": "static-7.986",
    "hr": "static-7.986",
    "hu": "static-7.986",
    "id": "static-7.986",
    "it": "static-7.986",
    "ja": "static-7.986",
    "ko": "static-7.986",
    "lt": "static-7.986",
    "ms": "static-7.986",
    "nl": "static-7.986",
    "no": "static-7.986",
    "pl": "static-7.986",
    "pt-br": "static-7.986",
    "pt-pt": "static-7.986",
    "ro": "static-7.986",
    "ru": "static-7.986",
    "sk": "static-7.986",
    "sl": "static-7.986",
    "sv": "static-7.986",
    "th": "static-7.986",
    "tl": "static-7.986",
    "tr": "static-7.986",
    "uk": "static-7.986",
    "vi": "static-7.986",
    "x-pseudo": "static-7.986",
    "zh-cn": "static-7.986",
    "zh-hk": "static-7.986",
    "zh-tw": "static-7.986"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ro', {version: 'static-7.986'}); }
})();


